import { render } from "./PagetreeItem.vue?vue&type=template&id=400723e8&scoped=true"
import script from "./PagetreeItem.vue?vue&type=script&lang=js"
export * from "./PagetreeItem.vue?vue&type=script&lang=js"

import "./PagetreeItem.vue?vue&type=style&index=0&id=400723e8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400723e8"]])

export default __exports__